import {h} from 'preact';

const lblNoResults = upi.i18n.getTextFromKey( 'lbl-noResults', 'No results' );

const SearchResultsEmpty = () =>
    <div className="flex justify-center w-full self-center text-xl py-8 px-4 bg-white">
        {lblNoResults}
    </div>;

export default SearchResultsEmpty;
